"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// jQuery(document).ready(function($) {
//     // Trigger save draft functionality when the "Save Draft" button is clicked
//     $('#cf7mls-save-draft-btn').on('click', function(e) {
//
//         e.preventDefault(); // Prevent default form action
//
//         // Collect form field values
//         var firstName = $('input[name="first_name"]').val();
//         var lastName = $('input[name="last_name"]').val();
//         var email = $('input[name="email"]').val();
//         var phone = $('input[name="phone"]').val();
//
//         // Validate email before sending request
//         if (!email) {
//             alert('Please enter a valid email address to save your application draft.');
//             return; // Stop if email is missing
//         }
//
//         // Prepare the data to be sent via AJAX
//         var formData = {
//             action: 'save_application_draft',
//             save_draft: true, // Indicate this is a draft request
//             first_name: firstName, // Pass the first name field
//             last_name: lastName,  // Pass the last name field
//             email: email,         // Pass the email field
//             phone: phone          // Pass the phone field
//         };
//
//         // Send AJAX request to WordPress
//         $.ajax({
//             type: 'POST',
//             url: ajaxurl, // WordPress AJAX handler URL
//             data: formData,
//             success: function(response) {
//                 if (response.success) {
//                     alert(response.data.message); // Show success message with draft code
//                 } else {
//                     alert(response.data.message); // Show error message if any
//                 }
//             },
//             error: function() {
//                 alert('There was an error saving your draft. Please try again.');
//             }
//         });
//     });
// });
//
//
//
// jQuery(document).ready(function($) {
//     $('#retrieve-application-form').on('submit', function(e) {
//         e.preventDefault(); // Prevent default form action
//
//         // Collect form field values
//         var email = $('#email').val();
//         var application_code = $('#application_code').val();
//
//         // Validate fields
//         if (!email || !application_code) {
//             alert('Please enter both email and application code.');
//             return;
//         }
//
//         // Prepare the data to be sent via AJAX
//         var formData = {
//             action: 'retrieve_application_draft',
//             email: email,
//             application_code: application_code
//         };
//
//         // Send AJAX request to WordPress
//         $.ajax({
//             type: 'POST',
//             url: ajaxurl,
//             data: formData,
//             success: function(response) {
//                 if (response.success) {
//                     alert(response.data.message); // Show success message
//
//                     // Pre-fill the fields with data received from the server
//                     $('input[name="first_name"]').val(response.data.application_data.first_name);
//                     $('input[name="last_name"]').val(response.data.application_data.last_name);
//                     $('input[name="email"]').val(response.data.application_data.email);
//                     $('input[name="phone"]').val(response.data.application_data.phone);
//                 } else {
//                     alert(response.data.message); // Show error message
//                 }
//             },
//             error: function() {
//                 alert('There was an error retrieving your application. Please try again.');
//             }
//         });
//     });
// });
//
//
//
// jQuery(document).ready(function($) {
//     // Check if session storage contains application data
//     const applicationData = sessionStorage.getItem('applicationData');
//
//     if (applicationData) {
//         // Parse the JSON string into an object
//         const data = JSON.parse(applicationData);
//
//         alert(data);
//         // Pre-fill the fields
//         $('input[name="first_name"]').val(data.first_name);
//         $('input[name="last_name"]').val(data.last_name);
//         $('input[name="email"]').val(data.email);
//         $('input[name="phone"]').val(data.phone);
//     }
// });
//
// jQuery(document).ready(function($) {
//     // Check if session storage contains application data
//     const applicationData = sessionStorage.getItem('applicationData');
//     const applicationCode = sessionStorage.getItem('applicationCode');
//
//     if (applicationData) {
//         // Parse the JSON string into an object
//         const data = JSON.parse(applicationData);
//
//         // Pre-fill the fields
//         $('input[name="first_name"]').val(data.first_name);
//         $('input[name="last_name"]').val(data.last_name);
//         $('input[name="email"]').val(data.email);
//         $('input[name="phone"]').val(data.phone);
//     } else if (applicationCode) {
//         // Optionally, you can fetch the application details using the application code
//         // You can do an AJAX request to your server to fetch data based on application code
//         $.ajax({
//             type: 'POST',
//             url: ajaxurl,
//             data: {
//                 action: 'get_application_data',
//                 application_code: applicationCode,
//             },
//             success: function(response) {
//                 if (response.success) {
//                     // Pre-fill the fields with data received from the server
//                     $('input[name="first_name"]').val(response.data.first_name);
//                     $('input[name="last_name"]').val(response.data.last_name);
//                     $('input[name="email"]').val(response.data.email);
//                     $('input[name="phone"]').val(response.data.phone);
//                 } else {
//                     alert('Unable to retrieve application data.');
//                 }
//             },
//             error: function() {
//                 alert('There was an error retrieving your application data.');
//             }
//         });
//     }
// });

// JavaScript for saving the application draft
jQuery(document).ready(function ($) {
  // Trigger save draft functionality when the "Save Draft" button is clicked
  // $('.cg-save-draft-btn').on('click', function(e) {
  //     e.preventDefault(); // Prevent default form action
  //
  //     // Collect form field values
  //     var firstName = $('input[name="first_name"]').val();
  //     var lastName = $('input[name="last_name"]').val();
  //     var email = $('input[name="email"]').val();
  //     var phone = $('input[name="phone"]').val();
  //     var email = $('input[name="email"]').val();
  //     var phone = $('input[name="phone"]').val();
  //
  //     // Validate email before sending request
  //     if (!email) {
  //         alert('Please enter a valid email address to save your application draft.');
  //         return; // Stop if email is missing
  //     }
  //
  //     // Prepare the data to be sent via AJAX
  //     var formData = {
  //         action: 'save_application_draft',
  //         save_draft: true, // Indicate this is a draft request
  //         first_name: firstName, // Pass the first name field
  //         last_name: lastName,  // Pass the last name field
  //         email: email,         // Pass the email field
  //         phone: phone          // Pass the phone field
  //     };
  //
  //     // Send AJAX request to WordPress
  //     $.ajax({
  //         type: 'POST',
  //         url: ajaxurl, // WordPress AJAX handler URL
  //         data: formData,
  //         success: function(response) {
  //             if (response.success) {
  //                 // Save application data in session storage
  //                 sessionStorage.setItem('applicationData', JSON.stringify({
  //                     first_name: firstName,
  //                     last_name: lastName,
  //                     email: email,
  //                     phone: phone,
  //                     application_code: response.data.application_code // Save application code for retrieval
  //                 }));
  //                 alert(response.data.message); // Show success message with draft code
  //             } else {
  //                 alert(response.data.message); // Show error message if any
  //             }
  //         },
  //         error: function() {
  //             alert('There was an error saving your draft. Please try again.');
  //         }
  //     });
  // });

  $('.cg-save-draft-btn').on('click', function (e) {
    e.preventDefault(); // Prevent default form action

    // Initialize an object to hold the form data
    var formData = {
      action: 'save_application_draft',
      save_draft: true // Indicate this is a draft request
    };

    // Collect form field values dynamically
    // Collect form field values dynamically, including <select> elements
    $('input[name], textarea[name], select[name]').each(function () {
      var fieldName = $(this).attr('name');
      var fieldValue = $(this).val(); // This works for all input, textarea, and select elements

      if ($(this).is(':checkbox')) {
        // Check if the checkbox is checked; if not, store an explicit false
        fieldValue = $(this).is(':checked') ? 1 : 0;
      } else if ($(this).is('select')) {
        // For <select> elements, get the selected value
        fieldValue = $(this).find('option:selected').val();
      }

      // if ($(this).is('select')) {
      //     // For <select> elements, get the selected value
      //     fieldValue = $(this).find('option:selected').val();
      // } else {
      //     // For <input> and <textarea> elements, get the value as usual
      //     fieldValue = $(this).val();
      // }

      // Add field value to the formData object if not empty
      if (fieldValue) {
        formData[fieldName] = fieldValue;
      }
    });

    // Validate email before sending request
    if (!formData.email) {
      alert('Please enter a valid email address to save your application draft.');
      return; // Stop if email is missing
    }

    // Send AJAX request to WordPress
    $.ajax({
      type: 'POST',
      url: ajaxurl,
      // WordPress AJAX handler URL
      data: formData,
      success: function success(response) {
        if (response.success) {
          // Save application data in session storage
          sessionStorage.setItem('applicationData', JSON.stringify(_objectSpread({
            application_code: response.data.application_code
          }, formData)));
          alert(response.data.message); // Show success message with draft code
        } else {
          alert(response.data.message); // Show error message if any
        }
      },
      error: function error() {
        alert('There was an error saving your draft. Please try again.');
      }
    });
  });

  // Handle the retrieve application form submission
  $('#retrieve-application-form').on('submit', function (e) {
    e.preventDefault(); // Prevent default form action

    // Collect form field values
    var email = $('#email').val();
    var application_code = $('#application_code').val();

    // Validate fields
    if (!email || !application_code) {
      alert('Please enter both email and application code.');
      return;
    }

    // Prepare the data to be sent via AJAX
    var formData = {
      action: 'retrieve_application_draft',
      email: email,
      application_code: application_code
    };

    // Send AJAX request to WordPress
    $.ajax({
      type: 'POST',
      url: ajaxurl,
      // WordPress AJAX handler URL
      data: formData,
      success: function success(response) {
        if (response.success) {
          // Save application data in session storage
          sessionStorage.setItem('applicationData', JSON.stringify(response.data.application_data));
          if (response.data.application_status == 'draft') {
            alert(response.data.message); // Show success message
          }
          window.location.href = response.data.redirect;
        } else {
          alert(response.data.message); // Show error message
        }
      },
      error: function error() {
        alert('There was an error retrieving your application. Please try again.');
      }
    });
  });

  // // Trigger population on page load to handle draft retrieval on form load
  // setTimeout(function () {
  //     const applicationData = sessionStorage.getItem('applicationData');
  //     if (applicationData) {
  //         const data = JSON.parse(applicationData);
  //         // Pre-fill the form fields with saved data
  //         $('input[name="first_name"]').val(data.first_name);
  //         $('input[name="last_name"]').val(data.last_name);
  //         $('input[name="email"]').val(data.email);
  //         $('input[name="phone"]').val(data.phone);
  //     }
  // }, 500); // Delay to allow CF7 to fully render
});

// // Ensure the form fields are populated after CF7 is loaded
// $(document).on('wpcf7mailsent wpcf7submit', function () {
//     // Check if session storage contains application data
//     const applicationData = sessionStorage.getItem('applicationData');
//     if (applicationData) {
//         const data = JSON.parse(applicationData);
//         // Pre-fill the form fields with saved data
//         $('input[name="first_name"]').val(data.first_name);
//         $('input[name="last_name"]').val(data.last_name);
//         $('input[name="email"]').val(data.email);
//         $('input[name="phone"]').val(data.phone);
//     }
// });

jQuery(document).ready(function ($) {
  // Select the fieldset with the specific data attribute
  var targetFieldset = $('.fieldset-cf7mls[data-cf7mls-order="2"]');

  // Check if the fieldset exists
  if (targetFieldset.length) {
    // Find the submit button within the fieldset
    var submitButton = targetFieldset.find('.wpcf7-submit');

    // Check if the submit button exists
    if (submitButton.length) {
      // Move the submit button into the desired div and remove it from its original position
      submitButton.appendTo(targetFieldset.find('.cf7mls-btns')).addClass("action-button");
    }
  }
});

/*

document.addEventListener('DOMContentLoaded', function () {
    const textareas = document.querySelectorAll('textarea[data-limit]');

    function updateWordCount(event) {
        const textarea = event.target;
        const wordLimit = parseInt(textarea.getAttribute('data-limit'), 10);
        if (isNaN(wordLimit)) return;

        // Split text content into words
        let words = textarea.value.trim().split(/\s+/);
        let wordCount = words.length;

        // Update word count display if present
        const wordCountDisplay = textarea.closest('label').querySelector('.word-count');
        if (wordCountDisplay) {
            wordCountDisplay.textContent = `Words: ${wordCount} / ${wordLimit}`;
        }

        // If the word count exceeds the limit, truncate the words
        if (wordCount > wordLimit) {
            // Join back only the allowed words
            textarea.value = words.slice(0, wordLimit).join(' ');

            // Update word count display again after truncation
            if (wordCountDisplay) {
                wordCountDisplay.textContent = `Words: ${wordLimit} / ${wordLimit}`;
            }
        }
    }

    // Attach event listeners for input and paste events
    textareas.forEach(textarea => {
        textarea.addEventListener('input', updateWordCount);
        textarea.addEventListener('paste', function (event) {
            // Handle paste event with a small timeout to process content after paste
            setTimeout(() => updateWordCount(event), 0);
        });
    });
});
*/

document.addEventListener('DOMContentLoaded', function () {
  // Select all textareas with the data-limit attribute
  var textareas = document.querySelectorAll('textarea[data-limit]');
  function updateWordCount(textarea) {
    var wordLimit = parseInt(textarea.getAttribute('data-limit'), 10);
    if (isNaN(wordLimit)) return;

    // Get the text and split it into words
    var words = textarea.value.trim().split(/\s+/).filter(function (word) {
      return word.length > 0;
    });
    var wordCount = words.length;

    // Find and update the word count display
    var wordCountDisplay = textarea.closest('label').querySelector('.word-count');
    if (wordCountDisplay) {
      wordCountDisplay.textContent = "Words: ".concat(wordCount, " / ").concat(wordLimit);
    }

    // If the word count exceeds the limit, truncate the text
    if (wordCount > wordLimit) {
      textarea.value = words.slice(0, wordLimit).join(' ');

      // Update the word count display after truncation
      if (wordCountDisplay) {
        wordCountDisplay.textContent = "Words: ".concat(wordLimit, " / ").concat(wordLimit);
      }
    }
  }

  // Attach event listeners to each textarea and initialize word count
  textareas.forEach(function (textarea) {
    // Initialize word count on page load
    updateWordCount(textarea);

    // Listen for changes (input, paste, etc.)
    textarea.addEventListener('input', function () {
      updateWordCount(textarea);
    });

    // Handle paste event
    textarea.addEventListener('paste', function () {
      setTimeout(function () {
        return updateWordCount(textarea);
      }, 0);
    });
  });
});
document.addEventListener('wpcf7submit', function (event) {
  // Use the dynamic form ID passed from PHP
  if (event.detail.contactFormId == application_form_id) {
    // Check if the form submission was successful
    if (event.detail.status === 'mail_sent') {
      setTimeout(function () {
        // Redirect to the current website's base URL with "/application-status"
        location = window.location.origin + '/application-status';
      }, 500); // Wait for 0.5 seconds to redirect
    }
  }
}, false);